import { Button, Icon, Popover, PopoverInteractionKind, Position } from "@blueprintjs/core" 
import { __ } from "src/libs/utilities"
import MeatSelectorList from "../../views/landing/landing-edit/MeatSelectorList"
import { MouseEvent } from "react"

interface IAddBtnProps {
    onAdd: (type: string, n:number, ) => void
    component: string
}
export const AddBtn = (props: IAddBtnProps):JSX.Element => {
    switch(props.component) {
        case "LandingContent":
            return <AddMeatBtn {...props}/>
        default:
            return <AddFeedBtn {...props} />
    }
}

export const AddFeedBtn = (props: IAddBtnProps):JSX.Element => {
    return <Button 
        size="large" 
        fill 
        variant="minimal" 
        alignText="left"   
        onClick={ () => props.onAdd( props.component, 0 ) } 
        className="btn-stretch pl-3 pr-1 py-2 "
    >
        <div className="d-flex w-100 align-items-center justify-content-between">
            
            <div className="small opacity_5 letter-spacing-2 uppercase">
                { __( "Add new" ) }
            </div>
            <Icon icon={ "plus" } className="mr-2 hover" />
        </div>  
    </Button>
}
export const AddMeatBtn = (props: IAddBtnProps):JSX.Element => {
    const onNewSection = ( evt: MouseEvent, key: string, n:number=0) => {
        props.onAdd(key, n)
    }
    return <div >  
        <Popover 
            position={ Position.BOTTOM_LEFT }
            interactionKind={ PopoverInteractionKind.CLICK }
            content={ <MeatSelectorList onClick={ onNewSection } /> } 
            portalClassName="z-index-130" 
            className="edit-button-popover w-100"
        >
            <Button 
                size="large" 
                fill 
                variant="minimal" 
                alignText="left"   
                onClick={ () => {} } 
                className="btn-stretch pl-3 pr-1 py-2 "
            >
                <div className="d-flex w-100 align-items-center justify-content-between">
                    
                    <div className="small opacity_5 letter-spacing-2 uppercase">
                        { __( "Add new" ) }
                    </div>
                    <Icon icon={ "plus" } className="mr-2 hover" />
                </div>  
            </Button>
        </Popover>
    </div> 
}